export const GOALS_CONFIG_RESPONSE = {
	'resultMap': {
		'REPORT': [
			{
				'data': {
					'goals': [
						{
							'isEnabled': true,
							'isDefault': true,
							'goalId': 'generateIncome',
							'goalName': 'Generate Income',
							'icon': 'BLK_icn_income_rgb-26px.svg',
							'targetText': 'target return',
							'targets': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
							'defaultTarget': 10,
							'relatedResources': [
								{
									'resourceId': 'resOne',
									'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/alternative-investments',
									'resourceValue': 'Learn more about alternatives'
								},
								{
									'resourceId': 'resTwo',
									'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/systematic-fixed-income-outlook',
									'resourceValue': 'Five wildcards for 2021'
								},
								{
									'resourceId': 'resTwo',
									'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/advisor-insights-guide',
									'resourceValue': 'Advisor insights guide'
								}
							],
							'tips': ['6040PRESSURE', 'LOOKINGFORWARD']
						},
						{
							'isEnabled': true,
							'isDefault': false,
							'goalId': 'increaseReturn',
							'goalName': 'Increase Return',
							'icon': 'BLK_icn_savings_rgb-26px.svg',
							'targetText': 'target return',
							'targets': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
							'defaultTarget': 10,
							'relatedResources': [
								{
									'resourceId': 'resOne',
									'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/alternative-investments',
									'resourceValue': 'Learn more about alternatives'
								},
								{
									'resourceId': 'resTwo',
									'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/systematic-fixed-income-outlook',
									'resourceValue': 'Five wildcards for 2021'
								},
								{
									'resourceId': 'resTwo',
									'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/advisor-insights-guide',
									'resourceValue': 'Advisor insights guide'
								}
							],
							'tips': ['6040PRESSURE', 'LOOKINGFORWARD']
						},
						{
							'isEnabled': true,
							'isDefault': false,
							'goalId': 'reduceRisk',
							'goalName': 'Reduce Risk',
							'icon': 'BLK_icn_risk_cone_rgb-26px.svg',
							'targetText': 'target return',
							'targets': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
							'defaultTarget': 10,
							'relatedResources': [
								{
									'resourceId': 'resOne',
									'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/alternative-investments',
									'resourceValue': 'Learn more about alternatives'
								},
								{
									'resourceId': 'resTwo',
									'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/systematic-fixed-income-outlook',
									'resourceValue': 'Five wildcards for 2021'
								},
								{
									'resourceId': 'resTwo',
									'resourceLink': 'https://www.blackrock.com/us/financial-professionals/insights/advisor-insights-guide',
									'resourceValue': 'Advisor insights guide'
								}
							],
							'tips': ['6040PRESSURE', 'LOOKINGFORWARD']
						}
					]
				}
			}
		]
	}
};
